import paxios from "@/common/paxios";
import { setupCache } from "axios-cache-adapter";
import { API_SERVICE } from "@/common/consts";

const cache = setupCache({
	exclude: { query: false },
	maxAge: 15 * 60 * 1000,
	debug: process.env.NODE_ENV !== "production",
});

/**
 * Export an Axios instance with GET requests `in-memory` cache adapter
 * and configured to query the Unscrambler Service
 */
export default paxios.create({
	baseURL: API_SERVICE,
	adapter: cache.adapter,
});
